module.exports = __webpack_public_path__ + "static/media/launch_fishing_marker.f96e402d.svg";